// Підключення функціоналу "Чертоги Фрілансера"
// import { isMobile } from "./functions.js";
// // Підключення списку активних модулів
// import { flsModules } from "./modules.js";

// import { spollers } from './spollers.js';

import { isMobile, spollers } from "./functions.js";
import { flsModules } from "./modules.js";

// document.addEventListener("change", function (e) {
//   if (e.target.name === "brand") {
//     const brandId = e.target.value;

//     if (!brandId) {
//       document.getElementById("model-select").innerHTML =
//         '<option value="">Все модели</option>';
//       return;
//     }

//     fetch(`/wp-json/wp/v2/auto_make?parent=${brandId}&per_page=100`)
//       .then((res) => res.json())
//       .then((data) => {
//         const select = document.getElementById("model-select");
//         select.innerHTML = '<option value="">Все модели</option>';

//         data.forEach((term) => {
//           const option = document.createElement("option");
//           option.value = term.id;
//           option.textContent = term.name;
//           select.appendChild(option);
//         });
//       });
//   }
// });

// document.addEventListener("change", function (e) {

//   if (e.target.name === "brand") {

//     const brandId = e.target.value;

//     if (!brandId) {
//       document.getElementById("model-select").innerHTML =
//         '<option value="">Все модели</option>';
//       return;
//     }

//     fetch(`/wp-json/wp/v2/moto_make?parent=${brandId}&per_page=100`)
//       .then((res) => res.json())
//       .then((data) => {

//         const select = document.getElementById("model-select");

//         select.innerHTML = '<option value="">Все модели</option>';

//         data.forEach((term) => {

//           const option = document.createElement("option");

//           option.value = term.id;
//           option.textContent = term.name;

//           select.appendChild(option);

//         });

//       });

//   }

// });


document.addEventListener("change", function (e) {

  if (e.target.name === "brand") {

    const brandId = e.target.value;
    const taxonomy = e.target.dataset.taxonomy;

    const select = document.getElementById("model-select");

    if (!brandId) {

      select.innerHTML = '<option value="">Все модели</option>';
      return;

    }

    fetch(`/wp-json/wp/v2/${taxonomy}?parent=${brandId}&per_page=100`)
      .then((res) => res.json())
      .then((data) => {

        select.innerHTML = '<option value="">Все модели</option>';

        data.forEach((term) => {

          const option = document.createElement("option");

          option.value = term.id;
          option.textContent = term.name;

          select.appendChild(option);

        });

      });

  }

});


const toggleBtn = document.querySelector(".filters-toggle");
const wrapper = document.querySelector(".auto-filters");

if (toggleBtn && wrapper) {
  const showText = toggleBtn.dataset.show;
  const hideText = toggleBtn.dataset.hide;

  toggleBtn.addEventListener("click", () => {
    wrapper.classList.toggle("expanded");

    toggleBtn.textContent = wrapper.classList.contains("expanded")
      ? hideText
      : showText;
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector(".filters-togglemob");
  const sidebar = document.querySelector(".archive-sidebar");
  const overlay = document.querySelector(".filters-overlay");
  const closeBtn = document.querySelector(".filters-close");

  if (!toggle || !sidebar || !overlay) return;

  function openFilters() {
    sidebar.classList.add("active");
    overlay.classList.add("active");
    document.body.classList.add("filters-open");
  }

  function closeFilters() {
    sidebar.classList.remove("active");
    overlay.classList.remove("active");
    document.body.classList.remove("filters-open");
  }

  toggle.addEventListener("click", openFilters);
  overlay.addEventListener("click", closeFilters);

  if (closeBtn) {
    closeBtn.addEventListener("click", closeFilters);
  }

  /* ======================
     SIMPLE & SAFE SWIPE
  ====================== */

  let startX = 0;

  sidebar.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  });

  sidebar.addEventListener("touchend", (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = endX - startX;

    if (diff < -100) {
      // свайп вліво
      closeFilters();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const switcher = document.querySelector(".js-lang-switcher");
  if (!switcher) return;

  const button = switcher.querySelector(".lang-switcher__current");
  const links = switcher.querySelectorAll(".lang-switcher__item");

  // Toggle dropdown
  button.addEventListener("click", function (e) {
    e.stopPropagation();
    switcher.classList.toggle("is-open");

    const expanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", !expanded);
  });

  // ✅ Автоматичне закриття при виборі мови
  links.forEach((link) => {
    link.addEventListener("click", function () {
      switcher.classList.remove("is-open");
      button.setAttribute("aria-expanded", false);
    });
  });

  // Закриття при кліку поза блоком
  document.addEventListener("click", function (e) {
    if (!switcher.contains(e.target)) {
      switcher.classList.remove("is-open");
      button.setAttribute("aria-expanded", false);
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".row-two__scroll").forEach((el) => {
    el.scrollLeft = el.scrollWidth - el.clientWidth;
  });
});

document
  .querySelectorAll(".row-one__scroll, .row-two__scroll")
  .forEach((slider) => {
    let isDown = false;
    let startX;
    let startScroll;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("is-dragging");
      startX = e.pageX;
      startScroll = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("is-dragging");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("is-dragging");
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const walk = e.pageX - startX;
      slider.scrollLeft = startScroll - walk;
    });
  });

// AJAX

document.addEventListener("DOMContentLoaded", function () {
  /*
    ==========================
    SEARCH
    ==========================
    */

  document.addEventListener("submit", function (e) {
    const form = e.target.closest(".js-ajax-search");
    if (!form) return;

    e.preventDefault();

    const postType = form.dataset.postType;
    const input = form.querySelector("input[name='search']");
    const searchValue = input.value.trim();

    const grid = document.querySelector(
      `[data-post-type="${postType}"].auto-grid`,
    );
    const loadMoreBtn = document.querySelector(
      `.js-load-more[data-post-type="${postType}"]`,
    );

    grid.dataset.page = 1;
    grid.dataset.search = searchValue;

    loadMoreBtn.dataset.page = 1;

    fetchPosts(postType, 1, searchValue, true);
  });

  /*
    ==========================
    LOAD MORE
    ==========================
    */

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".js-load-more");
    if (!btn) return;

    const postType = btn.dataset.postType;
    const grid = document.querySelector(
      `[data-post-type="${postType}"].auto-grid`,
    );

    let page = parseInt(btn.dataset.page) + 1;
    let search = grid.dataset.search || "";

    btn.dataset.page = page;

    fetchPosts(postType, page, search, false);
  });

  /*
    ==========================
    FETCH FUNCTION
    ==========================
    */

  function fetchPosts(postType, page, search = "", replace = false) {
    const grid = document.querySelector(
      `[data-post-type="${postType}"].auto-grid`,
    );
    const btn = document.querySelector(
      `.js-load-more[data-post-type="${postType}"]`,
    );

    btn.disabled = true;
    btn.textContent = "Loading...";

    fetch(themeData.ajax_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        action: "theme_load_more",
        post_type: postType,
        page: page,
        search: search,
        nonce: themeData.nonce,
      }),
    })
      .then((res) => res.text())
      .then((data) => {
        if (replace) {
          grid.innerHTML = data;
        } else {
          grid.insertAdjacentHTML("beforeend", data);
        }

        if (!data.trim()) {
          btn.remove();
        } else {
          btn.disabled = false;
          btn.textContent = "Load more";
        }
      })
      .catch((err) => {
        console.error(err);
        btn.disabled = false;
        btn.textContent = "Load more";
      });
  }

   /*
    ==========================
    SHOW / HIDE CLEAR BUTTON
    ==========================
    */

    document.addEventListener("input", function (e) {

        if (!e.target.classList.contains("js-search-input")) return;

        const form = e.target.closest("form");
        const clearBtn = form.querySelector(".js-search-clear");

        clearBtn.style.display = e.target.value.trim() ? "block" : "none";
    });


    /*
    ==========================
    CLEAR SEARCH
    ==========================
    */

    document.addEventListener("click", function (e) {

        const clearBtn = e.target.closest(".js-search-clear");
        if (!clearBtn) return;

        const form = clearBtn.closest("form");
        const input = form.querySelector(".js-search-input");
        const postType = form.dataset.postType;

        input.value = "";
        clearBtn.style.display = "none";

        const grid = document.querySelector(`[data-post-type="${postType}"].auto-grid`);
        const loadMoreBtn = document.querySelector(`.js-load-more[data-post-type="${postType}"]`);

        grid.dataset.page = 1;
        grid.dataset.search = "";
        loadMoreBtn.dataset.page = 1;

        fetchPosts(postType, 1, "", true);
    });
});
